import type { RoleType } from '@/features/role/domain/enums/RoleType'

export class CancelShipmentReasonMiniEntity {
  id?: number
  role?: RoleType
  text?: string | null
}
